// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Projects.css - Modern Kanban & Task Workspace Styling */

:root {
    --p-primary: #727cf5;
    --p-primary-hover: #5b67e0;
    --p-primary-light: #eff1fe;
    --p-dark: #0f172a;
    --p-text: #334155;
    --p-muted: #64748b;
    --p-border: #e2e8f0;
    --p-bg: #f8fafc;
    --p-card-bg: #ffffff;
    --p-success: #10b981;
    --p-warning: #f59e0b;
    --p-danger: #ef4444;
    --p-info: #06b6d4;
    --p-purple: #8b5cf6;
}

.projects-main-card {
    background: #ffffff;
    border-radius: 14px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.04);
    display: flex;
    flex-direction: column;
    height: calc(100vh - 85px);
    overflow: hidden;
}

/* Toolbar & Filters */
.projects-toolbar-wrapper {
    background: #ffffff;
    padding: 12px 18px;
    border-bottom: 1px solid #f1f5f9;
    z-index: 10;
    flex-shrink: 0;
}

.projects-toolbar-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.toolbar-left-group {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.toolbar-right-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

/* Segmented View Toggle (36px height) */
.segmented-view-toggle {
    display: inline-flex;
    align-items: stretch;
    background: #f1f5f9;
    padding: 3px;
    border-radius: 9px;
    border: 1px solid #e2e8f0;
    height: 36px;
    box-sizing: border-box;
}

.segment-btn {
    border: none;
    background: transparent;
    color: #64748b;
    font-size: 12.5px;
    font-weight: 600;
    padding: 0 14px;
    border-radius: 7px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    cursor: pointer;
    height: 100%;
    box-sizing: border-box;
}

.segment-btn:hover {
    color: #1e293b;
}

.segment-btn.active {
    background: #ffffff;
    color: #4338ca;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    font-weight: 700;
}

/* Search Box (36px height) */
.projects-search-box {
    position: relative;
    display: flex;
    align-items: center;
    width: 230px;
    height: 36px;
    box-sizing: border-box;
}

.projects-search-box .search-icon {
    position: absolute;
    left: 11px;
    color: #94a3b8;
    font-size: 13px;
    pointer-events: none;
}

.projects-search-input {
    padding-left: 32px !important;
    padding-right: 28px !important;
    height: 36px !important;
    min-height: 36px !important;
    border-radius: 9px !important;
    border: 1px solid #e2e8f0 !important;
    font-size: 12.5px !important;
    background-color: #f8fafc !important;
    color: #1e293b !important;
    box-sizing: border-box !important;
    transition: all 0.2s ease !important;
}

.projects-search-input:focus {
    background-color: #ffffff !important;
    border-color: var(--p-primary) !important;
    box-shadow: 0 0 0 3px rgba(114, 124, 245, 0.15) !important;
}

.btn-clear-search {
    position: absolute;
    right: 8px;
    background: none;
    border: none;
    color: #94a3b8;
    padding: 0;
    cursor: pointer;
    font-size: 14px;
    line-height: 1;
    display: flex;
    align-items: center;
    transition: color 0.15s ease;
}

.btn-clear-search:hover {
    color: #ef4444;
}

/* Project Info Pill Button (36px height) */
.project-info-pill-btn {
    height: 36px;
    box-sizing: border-box;
    font-size: 12.5px;
    font-weight: 600;
    border-radius: 9px;
    padding: 0 14px;
    color: #0284c7;
    border: 1px solid #bae6fd;
    background-color: #f0f9ff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.project-info-pill-btn:hover {
    background-color: #0284c7;
    color: #ffffff;
    border-color: #0284c7;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(2, 132, 199, 0.25);
}

/* Filter Select Wrappers (36px height) */
.filter-select-wrapper {
    flex-shrink: 0;
    height: 36px;
    box-sizing: border-box;
}

.project-select-box {
    min-width: 180px;
    max-width: 230px;
}

.milestone-select-box {
    min-width: 160px;
    max-width: 200px;
}

.member-select-box {
    min-width: 150px;
    max-width: 180px;
}

.priority-select-box {
    min-width: 130px;
    max-width: 150px;
}

.date-range-select-box {
    width: 190px;
}

.date-input-with-icon {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 36px;
    box-sizing: border-box;
}

.date-picker-prefix-icon {
    position: absolute;
    left: 10px;
    color: #94a3b8;
    font-size: 13px;
    pointer-events: none;
    z-index: 2;
}

.projects-date-input {
    height: 36px !important;
    min-height: 36px !important;
    font-size: 12px !important;
    border-radius: 9px !important;
    border: 1px solid #e2e8f0 !important;
    padding-left: 30px !important;
    padding-right: 10px !important;
    background-color: #ffffff !important;
    color: #1e293b !important;
    font-weight: 500 !important;
    width: 100% !important;
    box-sizing: border-box !important;
    transition: all 0.2s ease !important;
}

.projects-date-input:focus {
    border-color: var(--p-primary) !important;
    box-shadow: 0 0 0 3px rgba(114, 124, 245, 0.15) !important;
}

.clear-filters-btn {
    height: 36px;
    box-sizing: border-box;
    font-size: 12px;
    font-weight: 600;
    border-radius: 9px;
    padding: 0 12px;
    background: #fef2f2;
    border: 1px solid #fee2e2;
    color: #dc2626;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    transition: all 0.2s ease;
    cursor: pointer;
}

.clear-filters-btn:hover {
    background: #fee2e2;
    border-color: #fecaca;
    color: #b91c1c;
}

/* Active Filter Chips */
.active-filters-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #f1f5f9;
}

.active-filters-label {
    font-size: 11.5px;
    font-weight: 600;
    color: #64748b;
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.filter-chip {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 11.5px;
    font-weight: 500;
    background: #f8fafc;
    color: #1e293b;
    padding: 3px 10px;
    border-radius: 20px;
    border: 1px solid #e2e8f0;
}

.chip-key {
    color: #64748b;
    font-weight: 600;
}

.chip-remove {
    cursor: pointer;
    color: #94a3b8;
    font-size: 13px;
    line-height: 1;
    transition: color 0.15s ease;
}

.chip-remove:hover {
    color: #ef4444;
}

.clear-all-inline-btn {
    background: none;
    border: none;
    color: #dc2626;
    font-size: 11.5px;
    font-weight: 600;
    cursor: pointer;
    padding: 2px 6px;
    border-radius: 4px;
    transition: background 0.15s ease;
}

.clear-all-inline-btn:hover {
    background: #fee2e2;
    text-decoration: underline;
}

/* Content Viewport */
.projects-content-viewport {
    flex: 1 1;
    overflow-y: hidden;
    overflow-x: auto;
    background-color: #f8fafc;
    display: flex;
    flex-direction: column;
}

/* Kanban Board View - 100% Width Full Column Expansion */
.kanban-board-scroll {
    flex: 1 1;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 16px;
    display: flex;
    background-color: #f8fafc;
    width: 100%;
    box-sizing: border-box;
}

.kanban-columns-grid {
    display: flex;
    gap: 14px;
    width: 100%;
    min-width: 100%;
    align-items: stretch;
    height: 100%;
}

.kanban-col-wrapper {
    flex: 1 1;
    min-width: 250px;
    max-width: none;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.kanban-column-card {
    background: #f1f5f9;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.02);
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: calc(100vh - 180px);
    overflow: hidden;
}

.kanban-column-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 14px;
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}

.status-dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
}

.column-title-text {
    font-size: 13.5px;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.2px;
}

.column-count-badge {
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 20px;
    min-width: 24px;
    text-align: center;
    border: 1px solid rgba(0, 0, 0, 0.05);
}

.kanban-cards-container {
    padding: 10px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1 1;
}

.kanban-cards-container::-webkit-scrollbar {
    width: 5px;
}

.kanban-cards-container::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 4px;
}

.kanban-cards-container::-webkit-scrollbar-thumb:hover {
    background-color: #94a3b8;
}

/* Individual Kanban Task Card */
.task-kanban-card {
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 12px 14px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.03), 0 1px 2px rgba(15, 23, 42, 0.02);
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    position: relative;
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
}

.task-kanban-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 22px -4px rgba(15, 23, 42, 0.08), 0 4px 6px -2px rgba(15, 23, 42, 0.04);
    border-color: #cbd5e1;
}

.task-badge-pill {
    font-size: 9.5px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 6px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    display: inline-flex;
    align-items: center;
}

.worktype-pill {
    background-color: #f8fafc;
    color: #475569;
    border: 1px solid #e2e8f0;
}

.task-deadline-badge {
    font-size: 10px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 6px;
    border: 1px solid transparent;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
}

.task-card-title {
    font-size: 13px;
    font-weight: 650;
    color: #0f172a;
    line-height: 1.45;
    margin-bottom: 5px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.task-card-desc {
    font-size: 11.5px;
    color: #64748b;
    line-height: 1.45;
    margin-bottom: 7px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.task-milestone-tag {
    font-size: 11px;
    font-weight: 600;
    color: #4338ca;
    background: #eef2ff;
    border: 1px solid #e0e7ff;
    padding: 2px 8px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    width: fit-content;
    margin-bottom: 4px;
}

.task-card-footer {
    margin-top: 10px;
    padding-top: 8px;
    border-top: 1px solid #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.assignee-group {
    display: flex;
    align-items: center;
    gap: 8px;
}

.assignee-avatar-circle {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    color: #ffffff;
    font-size: 9.5px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 3px rgba(99, 102, 241, 0.3);
    flex-shrink: 0;
}

.assignee-avatar-circle.mini {
    width: 22px;
    height: 22px;
    font-size: 9px;
}

.assignee-avatar-circle.unassigned {
    background: #f1f5f9;
    color: #94a3b8;
    box-shadow: none;
    border: 1px solid #e2e8f0;
}

.assignee-name-text {
    font-size: 11.5px;
    font-weight: 600;
    color: #334155;
    max-width: 110px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.task-due-date {
    font-size: 11px;
    font-weight: 500;
    color: #64748b;
    display: inline-flex;
    align-items: center;
}

.task-meta-right {
    display: flex;
    align-items: center;
    gap: 8px;
}

.task-attachments-count {
    font-size: 11px;
    color: #64748b;
    display: flex;
    align-items: center;
    gap: 2px;
}

.kanban-empty-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 10px;
    color: #94a3b8;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    gap: 6px;
}

.empty-col-icon-wrap {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #cbd5e1;
}

/* List Table View */
.projects-table-container {
    flex: 1 1;
    overflow-y: auto;
    padding: 16px;
}

.projects-custom-table {
    margin-bottom: 0;
    background: #ffffff;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.02);
}

.projects-custom-table thead th {
    background-color: #f8fafc;
    color: #475569;
    font-size: 11.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 12px 16px;
    border-bottom: 1px solid #e2e8f0;
}

.projects-custom-table tbody tr.task-table-row {
    transition: background-color 0.15s ease;
    border-bottom: 1px solid #f1f5f9;
}

.projects-custom-table tbody tr.task-table-row:hover {
    background-color: #f8fafc;
}

.projects-custom-table tbody td {
    padding: 12px 16px;
    font-size: 12.5px;
}

.task-table-title {
    font-size: 13px;
    color: #0f172a;
}

/* Empty State */
.empty-workspace-state {
    text-align: center;
}

.empty-icon-circle {
    width: 68px;
    height: 68px;
    border-radius: 50%;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Modern Modals */
.task-detail-modal .modal-content,
.project-detail-modal .modal-content {
    border-radius: 18px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.25);
    overflow: hidden;
    background: #ffffff;
}

.custom-modal-header {
    padding: 22px 26px 14px 26px;
    background: #ffffff;
    border-bottom: 1px solid #f1f5f9;
    position: relative;
}

.btn-modal-close-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    flex-shrink: 0;
}

.btn-modal-close-icon:hover {
    background: #fee2e2;
    border-color: #fecaca;
    color: #dc2626;
    transform: rotate(90deg);
}

.task-status-pill-header {
    font-size: 11px;
    font-weight: 700;
    padding: 3px 10px;
    border-radius: 20px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    letter-spacing: 0.2px;
    text-transform: capitalize;
    border: 1px solid rgba(0, 0, 0, 0.04);
}

.status-dot-mini {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    display: inline-block;
}

.task-modal-main-title {
    font-size: 18.5px;
    font-weight: 750;
    color: #0f172a;
    line-height: 1.4;
    margin: 6px 0 0 0;
    letter-spacing: -0.2px;
}

.project-modal-main-title {
    font-size: 21px;
    font-weight: 800;
    color: #0f172a;
    margin: 4px 0 0 0;
    letter-spacing: -0.3px;
}

.custom-modal-body {
    padding: 20px 26px 26px 26px;
    background: #f8fafc;
}

.task-modal-body-layout,
.modal-body-layout {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.modal-content-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 16px 18px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.02);
}

.card-section-label {
    font-size: 11.5px;
    font-weight: 700;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
}

.task-modal-desc-text {
    font-size: 13.5px;
    color: #334155;
    line-height: 1.6;
    white-space: pre-line;
}

/* Modern 4-Card Metadata Grid */
.modal-meta-grid-modern {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
}

.meta-card-modern {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px 16px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.02);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 78px;
}

.meta-card-header {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    margin-bottom: 4px;
}

.meta-card-header i {
    font-size: 12px;
}

.text-indigo {
    color: #6366f1 !important;
}

.text-purple {
    color: #8b5cf6 !important;
}

.text-cyan {
    color: #06b6d4 !important;
}

.text-emerald {
    color: #10b981 !important;
}

.meta-card-val {
    font-size: 13px;
    color: #0f172a;
    line-height: 1.35;
}

.attachments-list-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 10px;
    margin-top: 8px;
}

.attachment-item-card {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    color: #1e293b;
    transition: all 0.2s ease;
}

.attachment-item-card:hover {
    background: #ffffff;
    border-color: var(--p-primary);
    box-shadow: 0 4px 12px rgba(114, 124, 245, 0.12);
    color: var(--p-primary);
    transform: translateY(-1px);
}

.att-icon-wrap {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    background: #eff6ff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.att-name {
    font-size: 12px;
    font-weight: 600;
    display: block;
}

/* Modal Footer */
.custom-modal-footer {
    padding: 14px 26px;
    background: #ffffff;
    border-top: 1px solid #f1f5f9;
    display: flex;
    justify-content: flex-end;
}

.btn-modern-close {
    padding: 7px 22px;
    font-size: 13px;
    font-weight: 600;
    border-radius: 8px;
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    color: #334155;
    transition: all 0.2s ease;
    cursor: pointer;
}

.btn-modern-close:hover {
    background: #e2e8f0;
    border-color: #cbd5e1;
    color: #0f172a;
}

/* Project Modal Layout Details */
.modal-project-tag {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    color: #2563eb;
    background: #dbeafe;
    padding: 2px 8px;
    border-radius: 12px;
    width: fit-content;
}

.modal-desc-content {
    font-size: 13px;
    color: #475569;
    line-height: 1.6;
    margin-bottom: 0;
}

.status-badge-pill {
    font-size: 11px;
    font-weight: 700;
    padding: 3px 9px;
    border-radius: 12px;
    width: fit-content;
    text-transform: capitalize;
    display: inline-block;
}

.status-badge-pill.ongoing {
    background: #dbeafe;
    color: #1d4ed8;
}

.status-badge-pill.completed,
.status-badge-pill.delivered {
    background: #d1fae5;
    color: #047857;
}

.resource-links-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 8px;
    margin-top: 6px;
}

.resource-link-card {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-decoration: none;
    color: #1e293b;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.2s ease;
}

.resource-link-card:hover {
    background: #ffffff;
    border-color: var(--p-primary);
    color: var(--p-primary);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.website-cred-card {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 12px 14px;
    margin-bottom: 8px;
}

.web-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    font-weight: 700;
}

.cred-row {
    font-size: 12px;
    background: #ffffff;
    padding: 6px 10px;
    border-radius: 6px;
    border: 1px solid #edf2f7;
}

.tech-badge-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.tech-badge.large {
    background: #eff6ff;
    color: #1d4ed8;
    border: 1px solid #bfdbfe;
    font-size: 11.5px;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 6px;
}

.modal-team-list-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 8px;
}

.team-member-item {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #f8fafc;
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
}

.team-member-avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: linear-gradient(135deg, #7c3aed, #a855f7);
    color: #ffffff;
    font-size: 10.5px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.team-member-name {
    font-size: 12px;
    font-weight: 600;
    color: #1e293b;
    display: block;
}

.cp {
    cursor: pointer;
}

/* Responsive Rules for Projects */
@media (max-width: 1200px) {
    .projects-toolbar-row {
        flex-direction: column;
        align-items: stretch;
    }

    .toolbar-left-group,
    .toolbar-right-group {
        width: 100%;
    }

    .filter-select-wrapper {
        flex: 1 1;
        min-width: 150px;
    }

    .modal-meta-grid-modern {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 992px) {
    .projects-main-card {
        height: auto;
        min-height: calc(100vh - 120px);
    }

    .projects-toolbar-wrapper {
        padding: 12px 14px;
    }

    .kanban-column-card {
        max-height: none;
    }
}

@media (max-width: 768px) {
    .toolbar-left-group {
        flex-direction: column;
        align-items: stretch;
    }

    .segmented-view-toggle {
        width: 100%;
    }

    .segment-btn {
        flex: 1 1;
        justify-content: center;
    }

    .projects-search-box {
        width: 100%;
        max-width: 100%;
    }

    .project-info-pill-btn {
        width: 100%;
        justify-content: center;
    }

    .toolbar-right-group {
        flex-direction: column;
        align-items: stretch;
    }

    .filter-select-wrapper {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 100% !important;
    }

    .date-range-select-box {
        width: 100% !important;
    }

    .clear-filters-btn {
        width: 100%;
        justify-content: center;
    }

    .modal-meta-grid-modern {
        grid-template-columns: 1fr;
    }

    .custom-modal-header {
        padding: 16px 18px 12px 18px;
    }

    .custom-modal-body {
        padding: 16px 18px;
    }

    .custom-modal-footer {
        padding: 12px 18px;
    }
}

@media (max-width: 576px) {
    .kanban-board-scroll {
        padding: 10px 8px;
    }

    .modal-team-list-grid {
        grid-template-columns: 1fr;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Projects.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,kDAAkD;IAClD,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA,wCAAwC;AACxC;IACI,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kDAAkD;IAClD,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,uBAAuB;IACvB,2BAA2B;IAC3B,6BAA6B;IAC7B,oCAAoC;IACpC,4BAA4B;IAC5B,oCAAoC;IACpC,yBAAyB;IACzB,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,0DAA0D;AAC9D;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,UAAU;IACV,eAAe;IACf,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA,2CAA2C;AAC3C;IACI,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA,yCAAyC;AACzC;IACI,cAAc;IACd,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,6BAA6B;IAC7B,oCAAoC;IACpC,6BAA6B;IAC7B,8BAA8B;IAC9B,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;IAC3B,sBAAsB;IACtB,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;IACI,yCAAyC;IACzC,0DAA0D;AAC9D;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA,qBAAqB;AACrB;IACI,SAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,yDAAyD;AACzD;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,SAAW;IACX,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,SAAO;AACX;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,gCAAgC;AAChC;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,8EAA8E;IAC9E,kDAAkD;IAClD,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,0FAA0F;IAC1F,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6CAA6C;IAC7C,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;IACvC,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,kBAAkB;AAClB;;IAEI,mBAAmB;IACnB,yBAAyB;IACzB,oDAAoD;IACpD,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,kDAAkD;IAClD,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;IACrB,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,gDAAgD;IAChD,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,iCAAiC;AACjC;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,kCAAkC;AAClC;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,SAAO;QACP,gBAAgB;IACpB;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,+BAA+B;IACnC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAO;QACP,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;QACtB,0BAA0B;QAC1B,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["/* Projects.css - Modern Kanban & Task Workspace Styling */\n\n:root {\n    --p-primary: #727cf5;\n    --p-primary-hover: #5b67e0;\n    --p-primary-light: #eff1fe;\n    --p-dark: #0f172a;\n    --p-text: #334155;\n    --p-muted: #64748b;\n    --p-border: #e2e8f0;\n    --p-bg: #f8fafc;\n    --p-card-bg: #ffffff;\n    --p-success: #10b981;\n    --p-warning: #f59e0b;\n    --p-danger: #ef4444;\n    --p-info: #06b6d4;\n    --p-purple: #8b5cf6;\n}\n\n.projects-main-card {\n    background: #ffffff;\n    border-radius: 14px;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.04);\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 85px);\n    overflow: hidden;\n}\n\n/* Toolbar & Filters */\n.projects-toolbar-wrapper {\n    background: #ffffff;\n    padding: 12px 18px;\n    border-bottom: 1px solid #f1f5f9;\n    z-index: 10;\n    flex-shrink: 0;\n}\n\n.projects-toolbar-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.toolbar-left-group {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.toolbar-right-group {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n/* Segmented View Toggle (36px height) */\n.segmented-view-toggle {\n    display: inline-flex;\n    align-items: stretch;\n    background: #f1f5f9;\n    padding: 3px;\n    border-radius: 9px;\n    border: 1px solid #e2e8f0;\n    height: 36px;\n    box-sizing: border-box;\n}\n\n.segment-btn {\n    border: none;\n    background: transparent;\n    color: #64748b;\n    font-size: 12.5px;\n    font-weight: 600;\n    padding: 0 14px;\n    border-radius: 7px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    cursor: pointer;\n    height: 100%;\n    box-sizing: border-box;\n}\n\n.segment-btn:hover {\n    color: #1e293b;\n}\n\n.segment-btn.active {\n    background: #ffffff;\n    color: #4338ca;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n    font-weight: 700;\n}\n\n/* Search Box (36px height) */\n.projects-search-box {\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 230px;\n    height: 36px;\n    box-sizing: border-box;\n}\n\n.projects-search-box .search-icon {\n    position: absolute;\n    left: 11px;\n    color: #94a3b8;\n    font-size: 13px;\n    pointer-events: none;\n}\n\n.projects-search-input {\n    padding-left: 32px !important;\n    padding-right: 28px !important;\n    height: 36px !important;\n    min-height: 36px !important;\n    border-radius: 9px !important;\n    border: 1px solid #e2e8f0 !important;\n    font-size: 12.5px !important;\n    background-color: #f8fafc !important;\n    color: #1e293b !important;\n    box-sizing: border-box !important;\n    transition: all 0.2s ease !important;\n}\n\n.projects-search-input:focus {\n    background-color: #ffffff !important;\n    border-color: var(--p-primary) !important;\n    box-shadow: 0 0 0 3px rgba(114, 124, 245, 0.15) !important;\n}\n\n.btn-clear-search {\n    position: absolute;\n    right: 8px;\n    background: none;\n    border: none;\n    color: #94a3b8;\n    padding: 0;\n    cursor: pointer;\n    font-size: 14px;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n    transition: color 0.15s ease;\n}\n\n.btn-clear-search:hover {\n    color: #ef4444;\n}\n\n/* Project Info Pill Button (36px height) */\n.project-info-pill-btn {\n    height: 36px;\n    box-sizing: border-box;\n    font-size: 12.5px;\n    font-weight: 600;\n    border-radius: 9px;\n    padding: 0 14px;\n    color: #0284c7;\n    border: 1px solid #bae6fd;\n    background-color: #f0f9ff;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.project-info-pill-btn:hover {\n    background-color: #0284c7;\n    color: #ffffff;\n    border-color: #0284c7;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 6px rgba(2, 132, 199, 0.25);\n}\n\n/* Filter Select Wrappers (36px height) */\n.filter-select-wrapper {\n    flex-shrink: 0;\n    height: 36px;\n    box-sizing: border-box;\n}\n\n.project-select-box {\n    min-width: 180px;\n    max-width: 230px;\n}\n\n.milestone-select-box {\n    min-width: 160px;\n    max-width: 200px;\n}\n\n.member-select-box {\n    min-width: 150px;\n    max-width: 180px;\n}\n\n.priority-select-box {\n    min-width: 130px;\n    max-width: 150px;\n}\n\n.date-range-select-box {\n    width: 190px;\n}\n\n.date-input-with-icon {\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    height: 36px;\n    box-sizing: border-box;\n}\n\n.date-picker-prefix-icon {\n    position: absolute;\n    left: 10px;\n    color: #94a3b8;\n    font-size: 13px;\n    pointer-events: none;\n    z-index: 2;\n}\n\n.projects-date-input {\n    height: 36px !important;\n    min-height: 36px !important;\n    font-size: 12px !important;\n    border-radius: 9px !important;\n    border: 1px solid #e2e8f0 !important;\n    padding-left: 30px !important;\n    padding-right: 10px !important;\n    background-color: #ffffff !important;\n    color: #1e293b !important;\n    font-weight: 500 !important;\n    width: 100% !important;\n    box-sizing: border-box !important;\n    transition: all 0.2s ease !important;\n}\n\n.projects-date-input:focus {\n    border-color: var(--p-primary) !important;\n    box-shadow: 0 0 0 3px rgba(114, 124, 245, 0.15) !important;\n}\n\n.clear-filters-btn {\n    height: 36px;\n    box-sizing: border-box;\n    font-size: 12px;\n    font-weight: 600;\n    border-radius: 9px;\n    padding: 0 12px;\n    background: #fef2f2;\n    border: 1px solid #fee2e2;\n    color: #dc2626;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    transition: all 0.2s ease;\n    cursor: pointer;\n}\n\n.clear-filters-btn:hover {\n    background: #fee2e2;\n    border-color: #fecaca;\n    color: #b91c1c;\n}\n\n/* Active Filter Chips */\n.active-filters-bar {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n    margin-top: 10px;\n    padding-top: 10px;\n    border-top: 1px solid #f1f5f9;\n}\n\n.active-filters-label {\n    font-size: 11.5px;\n    font-weight: 600;\n    color: #64748b;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.filter-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 11.5px;\n    font-weight: 500;\n    background: #f8fafc;\n    color: #1e293b;\n    padding: 3px 10px;\n    border-radius: 20px;\n    border: 1px solid #e2e8f0;\n}\n\n.chip-key {\n    color: #64748b;\n    font-weight: 600;\n}\n\n.chip-remove {\n    cursor: pointer;\n    color: #94a3b8;\n    font-size: 13px;\n    line-height: 1;\n    transition: color 0.15s ease;\n}\n\n.chip-remove:hover {\n    color: #ef4444;\n}\n\n.clear-all-inline-btn {\n    background: none;\n    border: none;\n    color: #dc2626;\n    font-size: 11.5px;\n    font-weight: 600;\n    cursor: pointer;\n    padding: 2px 6px;\n    border-radius: 4px;\n    transition: background 0.15s ease;\n}\n\n.clear-all-inline-btn:hover {\n    background: #fee2e2;\n    text-decoration: underline;\n}\n\n/* Content Viewport */\n.projects-content-viewport {\n    flex: 1;\n    overflow-y: hidden;\n    overflow-x: auto;\n    background-color: #f8fafc;\n    display: flex;\n    flex-direction: column;\n}\n\n/* Kanban Board View - 100% Width Full Column Expansion */\n.kanban-board-scroll {\n    flex: 1;\n    overflow-x: auto;\n    overflow-y: hidden;\n    padding: 16px;\n    display: flex;\n    background-color: #f8fafc;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.kanban-columns-grid {\n    display: flex;\n    gap: 14px;\n    width: 100%;\n    min-width: 100%;\n    align-items: stretch;\n    height: 100%;\n}\n\n.kanban-col-wrapper {\n    flex: 1 1 0;\n    min-width: 250px;\n    max-width: none;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.kanban-column-card {\n    background: #f1f5f9;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.02);\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    max-height: calc(100vh - 180px);\n    overflow: hidden;\n}\n\n.kanban-column-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 14px;\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n}\n\n.status-dot {\n    width: 9px;\n    height: 9px;\n    border-radius: 50%;\n    display: inline-block;\n    flex-shrink: 0;\n}\n\n.column-title-text {\n    font-size: 13.5px;\n    font-weight: 700;\n    color: #0f172a;\n    letter-spacing: -0.2px;\n}\n\n.column-count-badge {\n    font-size: 11px;\n    font-weight: 700;\n    padding: 2px 8px;\n    border-radius: 20px;\n    min-width: 24px;\n    text-align: center;\n    border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.kanban-cards-container {\n    padding: 10px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    flex: 1;\n}\n\n.kanban-cards-container::-webkit-scrollbar {\n    width: 5px;\n}\n\n.kanban-cards-container::-webkit-scrollbar-thumb {\n    background-color: #cbd5e1;\n    border-radius: 4px;\n}\n\n.kanban-cards-container::-webkit-scrollbar-thumb:hover {\n    background-color: #94a3b8;\n}\n\n/* Individual Kanban Task Card */\n.task-kanban-card {\n    background: #ffffff;\n    border-radius: 10px;\n    border: 1px solid #e2e8f0;\n    padding: 12px 14px;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.03), 0 1px 2px rgba(15, 23, 42, 0.02);\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    position: relative;\n    user-select: none;\n    cursor: pointer;\n}\n\n.task-kanban-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 10px 22px -4px rgba(15, 23, 42, 0.08), 0 4px 6px -2px rgba(15, 23, 42, 0.04);\n    border-color: #cbd5e1;\n}\n\n.task-badge-pill {\n    font-size: 9.5px;\n    font-weight: 700;\n    padding: 2px 7px;\n    border-radius: 6px;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    display: inline-flex;\n    align-items: center;\n}\n\n.worktype-pill {\n    background-color: #f8fafc;\n    color: #475569;\n    border: 1px solid #e2e8f0;\n}\n\n.task-deadline-badge {\n    font-size: 10px;\n    font-weight: 700;\n    padding: 2px 7px;\n    border-radius: 6px;\n    border: 1px solid transparent;\n    white-space: nowrap;\n    display: inline-flex;\n    align-items: center;\n}\n\n.task-card-title {\n    font-size: 13px;\n    font-weight: 650;\n    color: #0f172a;\n    line-height: 1.45;\n    margin-bottom: 5px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.task-card-desc {\n    font-size: 11.5px;\n    color: #64748b;\n    line-height: 1.45;\n    margin-bottom: 7px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.task-milestone-tag {\n    font-size: 11px;\n    font-weight: 600;\n    color: #4338ca;\n    background: #eef2ff;\n    border: 1px solid #e0e7ff;\n    padding: 2px 8px;\n    border-radius: 6px;\n    display: inline-flex;\n    align-items: center;\n    width: fit-content;\n    margin-bottom: 4px;\n}\n\n.task-card-footer {\n    margin-top: 10px;\n    padding-top: 8px;\n    border-top: 1px solid #f1f5f9;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.assignee-group {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.assignee-avatar-circle {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #6366f1, #8b5cf6);\n    color: #ffffff;\n    font-size: 9.5px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 1px 3px rgba(99, 102, 241, 0.3);\n    flex-shrink: 0;\n}\n\n.assignee-avatar-circle.mini {\n    width: 22px;\n    height: 22px;\n    font-size: 9px;\n}\n\n.assignee-avatar-circle.unassigned {\n    background: #f1f5f9;\n    color: #94a3b8;\n    box-shadow: none;\n    border: 1px solid #e2e8f0;\n}\n\n.assignee-name-text {\n    font-size: 11.5px;\n    font-weight: 600;\n    color: #334155;\n    max-width: 110px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.task-due-date {\n    font-size: 11px;\n    font-weight: 500;\n    color: #64748b;\n    display: inline-flex;\n    align-items: center;\n}\n\n.task-meta-right {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.task-attachments-count {\n    font-size: 11px;\n    color: #64748b;\n    display: flex;\n    align-items: center;\n    gap: 2px;\n}\n\n.kanban-empty-col {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 40px 10px;\n    color: #94a3b8;\n    font-size: 12px;\n    font-weight: 500;\n    text-align: center;\n    gap: 6px;\n}\n\n.empty-col-icon-wrap {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    color: #cbd5e1;\n}\n\n/* List Table View */\n.projects-table-container {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px;\n}\n\n.projects-custom-table {\n    margin-bottom: 0;\n    background: #ffffff;\n    border-radius: 10px;\n    overflow: hidden;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.02);\n}\n\n.projects-custom-table thead th {\n    background-color: #f8fafc;\n    color: #475569;\n    font-size: 11.5px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    padding: 12px 16px;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.projects-custom-table tbody tr.task-table-row {\n    transition: background-color 0.15s ease;\n    border-bottom: 1px solid #f1f5f9;\n}\n\n.projects-custom-table tbody tr.task-table-row:hover {\n    background-color: #f8fafc;\n}\n\n.projects-custom-table tbody td {\n    padding: 12px 16px;\n    font-size: 12.5px;\n}\n\n.task-table-title {\n    font-size: 13px;\n    color: #0f172a;\n}\n\n/* Empty State */\n.empty-workspace-state {\n    text-align: center;\n}\n\n.empty-icon-circle {\n    width: 68px;\n    height: 68px;\n    border-radius: 50%;\n    background: #f1f5f9;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Modern Modals */\n.task-detail-modal .modal-content,\n.project-detail-modal .modal-content {\n    border-radius: 18px;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.25);\n    overflow: hidden;\n    background: #ffffff;\n}\n\n.custom-modal-header {\n    padding: 22px 26px 14px 26px;\n    background: #ffffff;\n    border-bottom: 1px solid #f1f5f9;\n    position: relative;\n}\n\n.btn-modal-close-icon {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: 1px solid #e2e8f0;\n    background: #f8fafc;\n    color: #64748b;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    flex-shrink: 0;\n}\n\n.btn-modal-close-icon:hover {\n    background: #fee2e2;\n    border-color: #fecaca;\n    color: #dc2626;\n    transform: rotate(90deg);\n}\n\n.task-status-pill-header {\n    font-size: 11px;\n    font-weight: 700;\n    padding: 3px 10px;\n    border-radius: 20px;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    letter-spacing: 0.2px;\n    text-transform: capitalize;\n    border: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.status-dot-mini {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    display: inline-block;\n}\n\n.task-modal-main-title {\n    font-size: 18.5px;\n    font-weight: 750;\n    color: #0f172a;\n    line-height: 1.4;\n    margin: 6px 0 0 0;\n    letter-spacing: -0.2px;\n}\n\n.project-modal-main-title {\n    font-size: 21px;\n    font-weight: 800;\n    color: #0f172a;\n    margin: 4px 0 0 0;\n    letter-spacing: -0.3px;\n}\n\n.custom-modal-body {\n    padding: 20px 26px 26px 26px;\n    background: #f8fafc;\n}\n\n.task-modal-body-layout,\n.modal-body-layout {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.modal-content-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 16px 18px;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.02);\n}\n\n.card-section-label {\n    font-size: 11.5px;\n    font-weight: 700;\n    color: #475569;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 8px;\n    display: flex;\n    align-items: center;\n}\n\n.task-modal-desc-text {\n    font-size: 13.5px;\n    color: #334155;\n    line-height: 1.6;\n    white-space: pre-line;\n}\n\n/* Modern 4-Card Metadata Grid */\n.modal-meta-grid-modern {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 12px;\n}\n\n.meta-card-modern {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 14px 16px;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.02);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    min-height: 78px;\n}\n\n.meta-card-header {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 11px;\n    font-weight: 700;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    margin-bottom: 4px;\n}\n\n.meta-card-header i {\n    font-size: 12px;\n}\n\n.text-indigo {\n    color: #6366f1 !important;\n}\n\n.text-purple {\n    color: #8b5cf6 !important;\n}\n\n.text-cyan {\n    color: #06b6d4 !important;\n}\n\n.text-emerald {\n    color: #10b981 !important;\n}\n\n.meta-card-val {\n    font-size: 13px;\n    color: #0f172a;\n    line-height: 1.35;\n}\n\n.attachments-list-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 10px;\n    margin-top: 8px;\n}\n\n.attachment-item-card {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    padding: 8px 12px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    text-decoration: none;\n    color: #1e293b;\n    transition: all 0.2s ease;\n}\n\n.attachment-item-card:hover {\n    background: #ffffff;\n    border-color: var(--p-primary);\n    box-shadow: 0 4px 12px rgba(114, 124, 245, 0.12);\n    color: var(--p-primary);\n    transform: translateY(-1px);\n}\n\n.att-icon-wrap {\n    width: 34px;\n    height: 34px;\n    border-radius: 8px;\n    background: #eff6ff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.att-name {\n    font-size: 12px;\n    font-weight: 600;\n    display: block;\n}\n\n/* Modal Footer */\n.custom-modal-footer {\n    padding: 14px 26px;\n    background: #ffffff;\n    border-top: 1px solid #f1f5f9;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.btn-modern-close {\n    padding: 7px 22px;\n    font-size: 13px;\n    font-weight: 600;\n    border-radius: 8px;\n    background: #f1f5f9;\n    border: 1px solid #e2e8f0;\n    color: #334155;\n    transition: all 0.2s ease;\n    cursor: pointer;\n}\n\n.btn-modern-close:hover {\n    background: #e2e8f0;\n    border-color: #cbd5e1;\n    color: #0f172a;\n}\n\n/* Project Modal Layout Details */\n.modal-project-tag {\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: #2563eb;\n    background: #dbeafe;\n    padding: 2px 8px;\n    border-radius: 12px;\n    width: fit-content;\n}\n\n.modal-desc-content {\n    font-size: 13px;\n    color: #475569;\n    line-height: 1.6;\n    margin-bottom: 0;\n}\n\n.status-badge-pill {\n    font-size: 11px;\n    font-weight: 700;\n    padding: 3px 9px;\n    border-radius: 12px;\n    width: fit-content;\n    text-transform: capitalize;\n    display: inline-block;\n}\n\n.status-badge-pill.ongoing {\n    background: #dbeafe;\n    color: #1d4ed8;\n}\n\n.status-badge-pill.completed,\n.status-badge-pill.delivered {\n    background: #d1fae5;\n    color: #047857;\n}\n\n.resource-links-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 8px;\n    margin-top: 6px;\n}\n\n.resource-link-card {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 8px 12px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    text-decoration: none;\n    color: #1e293b;\n    font-size: 12px;\n    font-weight: 600;\n    transition: all 0.2s ease;\n}\n\n.resource-link-card:hover {\n    background: #ffffff;\n    border-color: var(--p-primary);\n    color: var(--p-primary);\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);\n}\n\n.website-cred-card {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    padding: 12px 14px;\n    margin-bottom: 8px;\n}\n\n.web-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 13px;\n    font-weight: 700;\n}\n\n.cred-row {\n    font-size: 12px;\n    background: #ffffff;\n    padding: 6px 10px;\n    border-radius: 6px;\n    border: 1px solid #edf2f7;\n}\n\n.tech-badge-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n}\n\n.tech-badge.large {\n    background: #eff6ff;\n    color: #1d4ed8;\n    border: 1px solid #bfdbfe;\n    font-size: 11.5px;\n    font-weight: 600;\n    padding: 3px 10px;\n    border-radius: 6px;\n}\n\n.modal-team-list-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n    gap: 8px;\n}\n\n.team-member-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: #f8fafc;\n    padding: 8px 10px;\n    border-radius: 8px;\n    border: 1px solid #e2e8f0;\n}\n\n.team-member-avatar {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #7c3aed, #a855f7);\n    color: #ffffff;\n    font-size: 10.5px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.team-member-name {\n    font-size: 12px;\n    font-weight: 600;\n    color: #1e293b;\n    display: block;\n}\n\n.cp {\n    cursor: pointer;\n}\n\n/* Responsive Rules for Projects */\n@media (max-width: 1200px) {\n    .projects-toolbar-row {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .toolbar-left-group,\n    .toolbar-right-group {\n        width: 100%;\n    }\n\n    .filter-select-wrapper {\n        flex: 1;\n        min-width: 150px;\n    }\n\n    .modal-meta-grid-modern {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 992px) {\n    .projects-main-card {\n        height: auto;\n        min-height: calc(100vh - 120px);\n    }\n\n    .projects-toolbar-wrapper {\n        padding: 12px 14px;\n    }\n\n    .kanban-column-card {\n        max-height: none;\n    }\n}\n\n@media (max-width: 768px) {\n    .toolbar-left-group {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .segmented-view-toggle {\n        width: 100%;\n    }\n\n    .segment-btn {\n        flex: 1;\n        justify-content: center;\n    }\n\n    .projects-search-box {\n        width: 100%;\n        max-width: 100%;\n    }\n\n    .project-info-pill-btn {\n        width: 100%;\n        justify-content: center;\n    }\n\n    .toolbar-right-group {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .filter-select-wrapper {\n        width: 100% !important;\n        max-width: 100% !important;\n        min-width: 100% !important;\n    }\n\n    .date-range-select-box {\n        width: 100% !important;\n    }\n\n    .clear-filters-btn {\n        width: 100%;\n        justify-content: center;\n    }\n\n    .modal-meta-grid-modern {\n        grid-template-columns: 1fr;\n    }\n\n    .custom-modal-header {\n        padding: 16px 18px 12px 18px;\n    }\n\n    .custom-modal-body {\n        padding: 16px 18px;\n    }\n\n    .custom-modal-footer {\n        padding: 12px 18px;\n    }\n}\n\n@media (max-width: 576px) {\n    .kanban-board-scroll {\n        padding: 10px 8px;\n    }\n\n    .modal-team-list-grid {\n        grid-template-columns: 1fr;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
